<template>
  <div>
    <main-header></main-header>
    <div class="shippingbg">
      <div class="w1200">
        <div class="left">{{language[languagetype].zxfw}}<font v-if="username">·{{username.customerName}}</font></div>
        <div class="shippingnav">
          <router-link :to="{name:'trackpage'}" class="a2">{{lang == 1 ? '货物追踪' : 'Cargo Tracking'}}</router-link>
          <router-link :to="{name:'order'}" class="a2">{{lang == 1 ? '我的运单' : 'Order Center'}}</router-link>
          <router-link :to="{name:'express'}" class="a2">{{lang == 1 ? '快递跟踪' : 'Express'}}</router-link>
          <router-link :to="{name:'report'}" class="a2">{{lang == 1 ? '报表查询' : 'Report'}}</router-link>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="w1200">
        <div class="shippint-toptitle">{{language[languagetype].bbcx}}</div>
        <div class="shipping-main">
          <div class="shipping-main-top">
            <div class="shipping-main-top-nav">
              <div class="s">{{language[languagetype].zxqd}}</div>
              <div @click="fyqd">{{language[languagetype].fyqd}}</div>
              <div @click="kcqd">{{language[languagetype].kcqd}}</div>
            </div>
            <div class="shipping-main-topbox">
              <div class="shipping-main-top-selectbox">
                <div class="dateselect">
                  <div>
                    <span>PO No：</span>
                    <input type="text" v-model="pono" :placeholder="language[languagetype].input">
                  </div>
                  <div>
                    <span>{{language[languagetype].loadingport}}：</span>
                    <input type="text" v-model="loadPort" :placeholder="language[languagetype].please">
                  </div>
                </div>
                <div class="dateselect2">
                  <span>{{language[languagetype].estimatesail}}：</span>
                  <div class="box">
                    <div class="postition">
                      <input type="text" :placeholder="language[languagetype].please" @click="xiala(1)" v-model="plandatastart">
                    </div>
                    <span></span>
                    <div class="postition">
                      <input type="text" :placeholder="language[languagetype].please" @click="xiala(2)" v-model="plandataend">
                    </div>
                  </div>
                  <div :style="{ left: boxleft +'px'}" class="calendarwrap">
                    <calendarbox ref="boxshow" v-on:plandatastartfunc='texta' v-on:plandataendfunc='textb' v-on:datastartfunc='textc' v-on:dataendfunc='textd'></calendarbox>
                  </div>
                </div>
              </div>
              <div class="shipping-btnbox">
                <div class="find" @click="reset">{{language[languagetype].refresh}}</div> <div class="find" @click="find">{{language[languagetype].search}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-main-tablebg">
          <div class="order-main-table">
            <div class="order-main-table-th">
              <div></div>
              <div>PO No</div>
              <div>{{language[languagetype].loadingport}}</div>
              <div>{{language[languagetype].estimatesail}}</div>
            </div>
            <ul class="order-main-tabletdlist">
              <li v-for="(order,index) in orderlists" :key="index">
                <div class="order-main-table-td">
                  <div></div>
                  <div>
                    {{order.po}}
                  </div>
                  <div>
                    {{order.ctnno}}
                  </div>
                  <div>
                    {{formatDayTime(order.ctnTime)}}
                  </div>
                </div>
              </li>
            </ul>
            <div class="nodata" v-if="nodata">
              {{language[languagetype].nodata}}
            </div>
            <div class="newslist-pageindex">
              <a href="javascript:;" @click="page(1)">{{language[languagetype].first}}</a>
              <a href="javascript:;" @click="page(cur-1)">{{language[languagetype].prev}}</a>
              <a href="javascript:;" v-if="cur > 2 && all!=2">...</a>
              <a href="javascript:;" v-for="index in pageindexarr" :key="index" @click="page(index)" :class="{active:cur===index}">{{index}}</a>
              <a href="javascript:;" v-if="all > 2 && cur < all -1">...</a>
              <a href="javascript:;" @click="page(cur+1)">{{language[languagetype].next}}</a>
              <span>{{language[languagetype].gonga}}{{alllength}}{{language[languagetype].tiao}} {{language[languagetype].gongb}}{{all}}{{language[languagetype].ye}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <toast ref="toasttext"></toast>
    <div class="loading" v-if="loading"></div>
  </div>
</template>
<script>
import MainHeader from './header'
import calendarbox from '../components/calendar/calendar'
import toast from '../components/taast/toast'
import httppost from '../js/ajax'
let languagetext = require('../js/report.json')
export default {
  name: 'index',
  data () {
    return {
      pono: '',
      loadPort: '',
      dischargePort: '',
      mShipper: '',
      mConsignee: '',
      orderlists: [],
      plandatastart: '',
      plandataend: '',
      datastart: '',
      dataend: '',
      boxleft: 0,
      all: 0,
      cur: 1,
      alllength: 0,
      pageindexarr: [],
      language: {},
      languagetype: 'cn',
      nodata: false,
      loading: false
    }
  },
  methods: {
    xiala: function (num) {
      if (num === 1) {
        this.boxleft = 0
      } else if (num === 2) {
        this.boxleft = 300
      } else if (num === 3) {
        this.boxleft = 600
      } else if (num === 4) {
        this.boxleft = 860
      }
      this.$refs.boxshow.show(num)
    },
    texta: function (data) {
      this.plandatastart = data.replace(/\//g, '-')
    },
    textb: function (data) {
      this.plandataend = data.replace(/\//g, '-')
    },
    textc: function (data) {
      this.datastart = data.replace(/\//g, '-')
    },
    textd: function (data) {
      this.dataend = data.replace(/\//g, '-')
    },
    fyqd: function () {
      this.$router.push({name: 'fyqd'})
    },
    kcqd: function () {
      this.$router.push({name: 'kcqd'})
    },
    formatDayTime: function (val) {
      if (val) {
        let date = new Date(val)
        let Y = date.getFullYear()
        let M = date.getMonth() + 1
        let D = date.getDate()

        if (M < 10) {
          M = '0' + M
        }
        if (D < 10) {
          D = '0' + D
        }
        return Y + '.' + M + '.' + D
      } else {
        return ''
      }
    },
    reset: function () {
      this.pono = ''
      this.loadPort = ''
      this.plandatastart = ''
      this.plandataend = ''
    },
    find: function () {
      const that = this
      this.cur = 1
      that.loading = true
      httppost.post('Api/http', {
        name: 'portal.report.packageList.query',
        customerName: that.username.customerName,
        po: that.pono,
        ctnno: that.loadPort,
        ctnStartTime: that.plandatastart,
        ctnEndTime: that.plandataend,
        pageNo: 1,
        pageSize: '10'
      }).then((res) => {
        if (res.code === '0') {
          that.orderlists = res.data.list
          console.log(that.orderlists)
          that.all = res.data.pages
          that.alllength = res.data.total
          if (that.alllength === 0) {
            that.nodata = true
          } else {
            that.nodata = false
          }
          if (that.all >= 2) {
            that.pageindexarr = [1, 2]
          } else {
            that.pageindexarr = [1]
          }
          that.loading = false
        } else {
          that.$refs.toasttext.show(res.msg)
          that.loading = false
        }
      }).catch(err => {
        that.$refs.toasttext.show(err.msg)
        that.loading = false
      })
    },
    page (index) {
      const that = this
      that.loading = true
      if (index <= 0) {
        index = 1
      }
      if (index >= this.all) {
        index = this.all
      }
      if (index === 1) {
        if (this.all < 2) {
          this.pageindexarr = [1]
        } else {
          this.pageindexarr = [1, 2]
        }
      } else if (index === 2) {
        if (this.all < 3) {
          this.pageindexarr = [1, 2]
        } else {
          this.pageindexarr = [1, 2, 3]
        }
      } else {
        if (this.all < index + 1) {
          this.pageindexarr = [index - 1, index]
        } else {
          this.pageindexarr = [index - 1, index, index + 1]
        }
      }
      this.cur = index
      httppost.post('Api/http', {
        name: 'portal.report.packageList.query',
        customerName: that.username.customerName,
        po: that.pono,
        ctnno: that.loadPort,
        ctnStartTime: that.plandatastart,
        ctnEndTime: that.plandataend,
        pageNo: index,
        pageSize: '10'
      }).then((res) => {
        if (res.code === '0') {
          that.loading = false
          that.orderlists = res.data.list
        } else {
          that.loading = false
          that.$refs.toasttext.show(res.msg)
        }
      }).catch(err => {
        that.loading = false
        that.$refs.toasttext.show(err.msg)
      })
    }
  },
  created () {
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    that.username = JSON.parse(localStorage.getItem('username'))
    if (that.username == null) {
      setTimeout(function () {
        that.$refs.toasttext.show(that.language[that.languagetype].islogin)
      }, 300)
      setTimeout(function () {
        that.$router.push({name: 'login'})
      }, 1000)
    }
  },
  components: {
    MainHeader,
    calendarbox,
    toast
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .shippingbg{height: 140px;background: url("../assets/topsubbg.jpg") center 0 no-repeat;}
  .shippingbg .left{float: left;height: 140px;line-height: 140px;font-size: 40px;color: #fff;}
  .shippingbg .left font{font-size: 26px;margin-left: 5px;}
  .shippingbg .shippingnav{float: right;height: 36px;margin-top: 53px;}
  .shippingbg .shippingnav a{display: block;height: 36px;min-width: 96px;float: left;color: #fff;font-size: 16px;margin-left: 16px;text-align: center;line-height: 36px;background-color: #5b86e7;box-sizing: border-box;padding: 0 5px;}
  .shippingbg .shippingnav a:hover{background-color: #fff;color: #336bed;border-radius: 1px;}
  .page{min-height: 600px;background-color: #f6f6f6;padding-bottom: 20px;}
  .shippint-toptitle{height: 92px;padding-top: 9px;line-height: 92px;color: #333;font-size: 30px;}
  .shipping-main{width: 100%;background-color: #fff;}
  .shipping-main-top{width: 100%;height: 180px;box-sizing: border-box;padding: 0 30px;overflow: visible;}
  .shipping-main-top-nav{height: 50px;width: 100%;display: flex;padding-top: 22px;border-bottom: 1px solid #c5c5c5;}
  .shipping-main-top-nav div{width:110px;height: 36px;margin-right: 4px;text-align: center;line-height: 36px;cursor: pointer;}
  .shipping-main-top-nav .s{background: #336bed;color: #fff;}
  .shipping-main-topbox{width: 100%;height: auto;overflow:visible;margin-top: 10px;}
  .shipping-main-top-selectbox .dateselect{width: auto;display: flex;align-items: center;}
  .shipping-main-top-selectbox .dateselect div{width: 240px;display: flex;align-items: center;margin-right: 15px;}
  .shipping-main-top-selectbox .dateselect span{width: 60px;flex-shrink: 0;text-align: center;}
  .shipping-main-top-selectbox .dateselect select{width: 186px;height: 32px;border:none;outline:none;box-sizing: border-box;border: 1px solid #c5c5c5;color: #c5c5c5;}
  .shipping-main-top-selectbox .dateselect input{width: 186px;height: 32px;border:none;outline:none;box-sizing: border-box;border: 1px solid #c5c5c5;color: #333;text-indent: 4px}
  .shipping-main-top-selectbox .dateselect input::placeholder{color: #999;}
  .input{background:url("../assets/down.png") 156px center no-repeat}
  .shipping-main-top-selectbox .dateselect div:nth-child(2){justify-content: flex-end;}
  .shipping-main-top-selectbox{display: flex;height: 52px;position: relative;}
  .shipping-main-top-selectbox .dateselect2{width: 560px;display: flex;align-items: center;position: relative;}
  .shipping-main-top-selectbox .dateselect2 span{width: 84px;flex-shrink: 0;}
  .shipping-main-top-selectbox .dateselect2 .box{width: 480px;height: 30px;border:1px solid #c5c5c5;display: flex;justify-content:space-between;align-items:center;}
  .shipping-main-top-selectbox .dateselect2 .box input{width: 184px;height: 30px;border: none;text-indent: 4px;background: url("../assets/date.png") 156px center no-repeat;}
  .shipping-main-top-selectbox .dateselect2 .box input::placeholder{color: #999;}
  .shipping-main-top-selectbox .dateselect2 .box span{height: 1px;width: 36px;background-color: #c6c6c6;}
  .shipping-btnbox{width: 100%;height: 36px;display: flex;flex-direction: row-reverse;margin-top: 10px;}
  .shipping-btnbox .find{width: 110px;height: 32px;border-radius: 2px;background-color: #fff;height: 32px;line-height: 32px;text-align: center;color: #999999;margin-left: 5px;cursor: pointer;border:1px solid #C5C5C5}
  .shipping-btnbox .find:hover{background-color: #2562EF;border:1px solid #2562EF;color: #fff;}
  .order-main-tablebg{width: 100%;height: auto;box-sizing: border-box;padding: 30px;background-color: #fff;min-height: 300px;}
  .order-main-table{width: 100%;height: auto;box-sizing: border-box;}
  .order-main-table-th{width: 100%;height: 50px;overflow: hidden;display: flex;background-color: #f6f6f6;}
  .order-main-table-th div{flex-shrink: 0;height: 50px;font-weight: bold;line-height: 50px;}
  .order-main-table-th div:nth-child(1){width: 23px;}
  .order-main-table-th div:nth-child(2){width: 433px;}
  .order-main-table-th div:nth-child(3){width: 377px;}
  .order-main-table-th div:nth-child(4){width: 308px;}
  .order-main-tabletdlist{width: 100%;height: auto;overflow: hidden;}
  .order-main-tabletdlist li{width: 100%;height: auto;overflow: hidden;}
  .order-main-tabletdlist li:nth-child(even){background-color: #f6f6f6;}
  .order-main-table-td{width: 100%;height: auto;display: flex;}
  .order-main-table-td:hover{background-color: #a4b3d7;}
  .order-main-table-td div{flex-shrink: 0;height: auto;min-height: 74px;color: #999999;font-size: 12px;line-height: 74px;box-sizing: border-box;box-sizing: border-box;padding-left: 4px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
  .order-main-table-td div:nth-child(1){width: 23px;}
  .order-main-table-td div:nth-child(2){width: 433px;}
  .order-main-table-td div:nth-child(3){width: 377px;}
  .order-main-table-td div:nth-child(4){width: 308px;}
  .order-main-table-td:hover div{color: #fff;}
  .calendarwrap{position: absolute;top: 45px;}
  .reset{cursor: pointer;}
  .newslist-pageindex{width: 100%;height: auto;overflow: hidden;text-align: center;margin-bottom: 5px;margin-top: 15px;}
  .newslist-pageindex a{display: inline-block;width: auto;height: 32px;background-color: #f2f2f2;color: #333333;font-size: 14px;line-height: 32px;min-width: 32px;box-sizing: border-box;padding: 0 5px; margin-left: 5px;margin-right: 5px;}
  .newslist-pageindex .active{background-color: #2a3c66;color:#fff}
  .newslist-pageindex a:hover{background-color: #2a3c66;color:#fff}
  .nodata{width: 100%;height: 50px;line-height: 50px;overflow: hidden;text-align: center;}
  .loading{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background:rgba(0, 0, 0, 0.5) url("../assets/loading_more.gif") center center no-repeat;z-index: 20;}
  </style>



// WEBPACK FOOTER //
// src/page/report.vue